import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children, admin }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="py-32 text-center text-slate-400">Caricamento...</div>;
  if (!user) return <Navigate to="/accedi" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};
